import { WSList, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { FlowMEChangeContext } from "..";
import { useUserId } from "../../../../../query/hooks/helpers";
import { useQueryPayerRows } from "../../../../../query/search/payer/queries/useQueryPayerRows";
import {
  useQueryMemberProfile,
  useQueryUserProfile
} from "../../../../../query/users/queries";
import { useFlowContext } from "../../../../../shared/components/Flow";
import { FormBusinessInformation } from "../../../components/FormBusinessInformation";
import { getProfileDataBusiness } from "../../../components/FormBusinessInformation/getProfileDataBusiness";
import { OnboardingStep } from "../../../types";

export const StepMaterialUpdateBusinessInformation: React.FC<
  OnboardingStep
> = props => {
  const [context, setContext] = useFlowContext<FlowMEChangeContext>();

  const userId = useUserId();
  const queryUser = useQueryUserProfile(userId);
  const queryMember = useQueryMemberProfile(userId);
  const profileData = useMemo(
    () => getProfileDataBusiness(queryMember.data),
    [queryMember.data]
  );

  const queryPayers = useQueryPayerRows();
  const payerCompanyName = useMemo(() => {
    const payer = queryPayers.data?.[0];

    if (!payer) {
      return undefined;
    }

    return {
      doingBusinessAs: payer.member?.profile?.company?.doingBusinessAs,
      legalBusinessName: payer.member?.profile?.company?.legalBusinessName
    };
  }, [queryPayers.data]);

  return (
    <WSList gap="2XL">
      <FormBusinessInformation
        country={context.accountType?.country || "US"}
        defaultValues={context.businessInformation || profileData}
        onBack={props.onBack}
        onSubmit={data => {
          setContext(prev => ({ ...prev, businessInformation: data }));
          props.onNext?.();
        }}
        show1099Message
        personalEmail={queryUser.data?.email}
        payerCompanyName={payerCompanyName}
      />

      <WSText.ParagraphXs color="gray400">
        The information on this page is required to setup your Wingspan account,
        if you exit or leave without completing this step, you will return to
        this page the next time you sign-in
      </WSText.ParagraphXs>
    </WSList>
  );
};
